import React from "react";

import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { MeltwaterProjectSection } from "../../containers/projects";

const MeltwaterProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Meltwater - Projects"
        description="Leading the frontend of a publishing product for a social media Saas. Vue, Stencil, web components, calendar-driven social publishing."
      />
      <MeltwaterProjectSection />
    </Layout>
  );
};

export default MeltwaterProjectPage;
